import { CommonEnums } from '../../common.enums';

export class Flagent_cfg {
    flagent_Id: number;
    fla_Cfg_Id: number;
    fla_Cfg_Type: String;
    fla_Cfg_Cd: String
    fla_Cfg_Name: String;
    fla_Cfg_Val: String;
    updateDt: Date;
    updateBy: String; //change
    cfg_Type: String;
    change_Ind: String;
    updatedFlag: String;

    constructor() {
        this.setDefaults();
    }

    setDefaults() {
        this.flagent_Id = CommonEnums.defaults.LONG_VAL;
        this.fla_Cfg_Id = CommonEnums.defaults.LONG_VAL;
        this.fla_Cfg_Type = CommonEnums.defaults.STRING_EMPTY;
        this.fla_Cfg_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fla_Cfg_Name = CommonEnums.defaults.STRING_EMPTY;
        this.fla_Cfg_Val = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date(); //TODO;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.cfg_Type = CommonEnums.defaults.STRING_EMPTY;
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.updatedFlag = CommonEnums.defaults.STRING_VAL_NO;

    }

    static parse(flagent_cfgTmp: Flagent_cfg): Flagent_cfg {
        let flagent_cfg: Flagent_cfg = new Flagent_cfg();
        flagent_cfg.copyFrom(flagent_cfgTmp);
        return flagent_cfg;
    }

    getPrimaryKey(): string {
        return this.flagent_Id +'.'+this.fla_Cfg_Id;
    }

    copy(): Flagent_cfg {
        let flagent_cfgTmp: Flagent_cfg = new Flagent_cfg();

        flagent_cfgTmp.flagent_Id = this.flagent_Id;
        flagent_cfgTmp.fla_Cfg_Id = this.fla_Cfg_Id;
        flagent_cfgTmp.fla_Cfg_Type = this.fla_Cfg_Type;
        flagent_cfgTmp.fla_Cfg_Cd = this.fla_Cfg_Cd;
        flagent_cfgTmp.fla_Cfg_Name = this.fla_Cfg_Name;
        flagent_cfgTmp.fla_Cfg_Val = this.fla_Cfg_Val;
        flagent_cfgTmp.updateDt = this.updateDt; //TODO;
        flagent_cfgTmp.updateBy = this.updateBy;
        flagent_cfgTmp.cfg_Type = this.cfg_Type;
        flagent_cfgTmp.change_Ind = this.change_Ind;
        flagent_cfgTmp.updatedFlag = this.updatedFlag;

        return flagent_cfgTmp;
    }


    copyFrom(flagent_cfgTmp: Flagent_cfg): void {
        this.flagent_Id = flagent_cfgTmp.flagent_Id;
        this.fla_Cfg_Id = flagent_cfgTmp.fla_Cfg_Id;
        this.fla_Cfg_Type = flagent_cfgTmp.fla_Cfg_Type;
        this.fla_Cfg_Cd = flagent_cfgTmp.fla_Cfg_Cd;
        this.fla_Cfg_Name = flagent_cfgTmp.fla_Cfg_Name;
        this.fla_Cfg_Val = flagent_cfgTmp.fla_Cfg_Val;
        this.updateDt = flagent_cfgTmp.updateDt;
        this.updateBy = flagent_cfgTmp.updateBy;
        this.cfg_Type = flagent_cfgTmp.cfg_Type;
        this.change_Ind = flagent_cfgTmp.change_Ind;
        this.updatedFlag = flagent_cfgTmp.updatedFlag;
    }

    compare(flagent_CfgTmp: Flagent_cfg): string {
        let flagent_CfgString: string = this.toString(false);
        let flagent_CfgTmpString: string = flagent_CfgTmp.toString(false);

        if (flagent_CfgString != flagent_CfgTmpString) {
            return flagent_CfgString + ', ' + flagent_CfgTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str:string= "Flagent_cfg [flagent_Id=" + this.flagent_Id + ", fla_Cfg_Id=" + this.fla_Cfg_Id +
            ", fla_Cfg_Type=" + this.fla_Cfg_Type + ", fla_Cfg_Cd=" + this.fla_Cfg_Cd +
            ", fla_Cfg_Name=" + this.fla_Cfg_Name + ", fla_Cfg_Val=" + this.fla_Cfg_Val +
            ", updateDt=" + this.updateDt + ", updateBy=" + this.updateBy +
            ", cfg_Type =" + this.cfg_Type + 
            ", updatedFlag=" + this.updatedFlag ;
    
            if (isNotCompare) {
                str += ", change_Ind=" + this.change_Ind; 
            }
    
            str += ']';
    
            return str;
        }
    }
    
